import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { LearningSectionFlowControlHelperService } from '../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service';
import { ThemeService } from '../../../../_helpers/theming-engine/theme.service';
import { TutorReportsHelperService } from '../../../../_helpers/tutor-reports-helper/tutor-reports-helper.service';
import { Baseline } from '../../../../_models';

@Component({
    selector: 'classic-ilp-section',
    templateUrl: './classic-ilp-section.component.html',
    styleUrls: ['./classic-ilp-section.component.css'],
    standalone: false
})
export class ClassicIlpSectionComponent extends BaseLearningSectionComponent implements OnInit {
  @Input() timelineSection: Baseline = new Baseline();

  // Lookup-backed display texts: getters (not init-time fields) so they resolve once
  // TutorReportsHelperService.ensureContext() has loaded keyStages/targetGrades.
  public get initialKeyStageText(): string {
    return this.tutorReportsHelperService.keyStages?.find(k => k.id == this.timelineSection.initialKeyStage)?.description ?? '';
  }

  public get initialLearningBandText(): string {
    return this.tutorReportsHelperService.targetGrades?.find(g => g.id == this.timelineSection.initialLearningBand)?.text ?? '';
  }

  public get targetKeyStageText(): string {
    return this.tutorReportsHelperService.keyStages?.find(k => k.id == this.timelineSection.targetKeyStage)?.description ?? '';
  }

  public get targetLearningBandText(): string {
    return this.tutorReportsHelperService.targetGrades?.find(g => g.id == this.timelineSection.targetLearningBand)?.text ?? '';
  }

  constructor(
    protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    public themeService: ThemeService,
    private tutorReportsHelperService: TutorReportsHelperService
  ) {
    super(flowHelperService, dialog);
    this.sectionTitle = 'Individual Learning Plan (Classic)';
  }

  ngOnInit() {
    
  }

}
